exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectBox[data-v-49b0c3d6]{position:absolute;left:0;right:0;max-height:20rem;z-index:100;overflow:scroll;background:#fff;box-shadow:0 0 10px hsla(0,0%,39%,.6);border-radius:5px}.list[data-v-49b0c3d6]:hover{background-color:hsla(0,0%,39%,.2)}.selectShaw[data-v-49b0c3d6]{position:fixed;z-index:10;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49b0c3d6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mySelect.vue
// module id = 200
// module chunks = 0